import { render, staticRenderFns } from "./orderInhotelInfoList.vue?vue&type=template&id=6edc821e&scoped=true"
import script from "./orderInhotelInfoList.vue?vue&type=script&lang=js"
export * from "./orderInhotelInfoList.vue?vue&type=script&lang=js"
import style0 from "./orderInhotelInfoList.vue?vue&type=style&index=0&id=6edc821e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc821e",
  null
  
)

export default component.exports